import { MatchScore } from 'features/match/matchSliceTypes';
import { Match } from 'interfaces/match';
import { MatchEventType } from '../../../enums/matchEventType';

export default function countEventPerTeam(matchEventTypeId: MatchEventType, match: Match): MatchScore {
  let home = 0;
  let away = 0;

  const { matchEvents, homeTeam, awayTeam } = match;

  matchEvents.forEach((event) => {
    if (event.matchEventTypeId === matchEventTypeId && event.team) {
      if (event.team.id === homeTeam.id) home++;
      if (event.team.id === awayTeam.id) away++;
    }
  });

  return {
    home,
    away,
  };
}
